import { Table, Tooltip, Typography } from "antd";
import { getColorForStatus } from "../utils";
import { formatRupee } from "../utils";

type DataType = {
  key: React.Key;
  username: string;
  fullName: string;
  email: string;
};

export const BorrowerDetails = ({
  borrowerViewDetails,
  isCaseDetailsPending,
}: any) => {
  const dpdStatus = borrowerViewDetails?.dpdStatus?.split(" ")[1];
  const dpdStatusBgColor = getColorForStatus(
    borrowerViewDetails?.dpdStatus || ""
  );

 const data = [
    {
      loanIdLabel: <span className="font-bold">Loan ID</span>,
      loanId: <span>{borrowerViewDetails?.loanId || "N/A"}</span>,
      dateOfPurchaseLabel: <span className="font-bold">Lender</span>,
      dateOfPurchase: (
        <span>{borrowerViewDetails?.clientName || "N/A"}</span>
      ),
      otherChargesLabel: <span className="font-bold">Product Name</span>,
      otherCharges: (
        <span>{borrowerViewDetails?.productName || "N/A"}</span>
      ),
    },
    {
      loanIdLabel: <span className="font-bold">Date of Purchase</span>,
      loanId: <span>{borrowerViewDetails?.dateOfPurchase || "N/A"}</span>,
      dateOfPurchaseLabel: <span className="font-bold">DPD Status</span>,
      dateOfPurchase: (
        <Tooltip title={borrowerViewDetails?.dpdStatus || "N/A"}>
          <Typography.Text
            style={{
              background: dpdStatusBgColor,
              padding:
                dpdStatus === "0-30" ? ".25rem 1.30rem" : ".25rem 1rem",
              borderRadius: "12px",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            {dpdStatus || "N/A"}
          </Typography.Text>
        </Tooltip>
      ),
      otherChargesLabel: <span className="font-bold">Loan Amount</span>,
      otherCharges: (
        <span>
          {borrowerViewDetails?.loanAmount
            ? formatRupee(borrowerViewDetails.loanAmount)
            : "N/A"}
        </span>
      ),
    },
    {
      loanIdLabel: <span className="font-bold">Due Amount</span>,
      loanId: (
        <span>
          {borrowerViewDetails?.dueAmount
            ? formatRupee(borrowerViewDetails.dueAmount)
            : "N/A"}
        </span>
      ),
      dateOfPurchaseLabel: <span className="font-bold">Interest Amount</span>,
      dateOfPurchase: (
        <span>
          {borrowerViewDetails?.interestAmount
            ? formatRupee(borrowerViewDetails.interestAmount)
            : "N/A"}
        </span>
      ),
      otherChargesLabel: <span className="font-bold">Other Charges</span>,
      otherCharges: (
        <span>
          {borrowerViewDetails?.otherCharges
            ? formatRupee(borrowerViewDetails.otherCharges)
            : "N/A"}
        </span>
      ),
    },
    {
      loanIdLabel: <span className="font-bold">Settlement Amount</span>,
      loanId: (
        <span>
          {borrowerViewDetails?.settlementAmount
            ? formatRupee(borrowerViewDetails.settlementAmount)
            : "N/A"}
        </span>
      ),
      dateOfPurchaseLabel: <span className="font-bold">Waiver Amount</span>,
      dateOfPurchase: (
        <span>
          {borrowerViewDetails?.waverAmount
            ? formatRupee(borrowerViewDetails.waverAmount)
            : "N/A"}
        </span>
      ),
      otherChargesLabel: <span className="font-bold">Final Offer Amount</span>,
      otherCharges: (
        <span>
          {borrowerViewDetails?.finalOfferAmount
            ? formatRupee(borrowerViewDetails.finalOfferAmount)
            : "N/A"}
        </span>
      ),
    },
    {
     loanIdLabel: <span className="font-bold">DPD (Days)</span>,
loanId: (
  <span>
    {borrowerViewDetails?.dpdCount != null
      ? `${borrowerViewDetails.dpdCount} Days`
      : "N/A"}
  </span>
),
      dateOfPurchaseLabel: <span className="font-bold">Borrower Age</span>,
      dateOfPurchase: (
        <span>
          {borrowerViewDetails?.borrowerAge
            ? `${borrowerViewDetails.borrowerAge} Years`
            : "N/A"}
        </span>
      ),
      otherChargesLabel: <span className="font-bold">Address</span>,
      otherCharges: (
       <span    
style={{
   display: "inline-block",
  width: "200px",
}}
     
        >{borrowerViewDetails?.address || "N/A"}</span>
      ),
    },
  ];
console.log(borrowerViewDetails,"borrowerViewDetails")
  const columns = [
    {
      dataIndex: "loanIdLabel",
      key: "loanIdLabel",
    },
    {
      dataIndex: "loanId",
      key: "loanId",
    },
    {
      dataIndex: "dateOfPurchaseLabel",
      key: "dateOfPurchaseLabel",
    },
    {
      dataIndex: "dateOfPurchase",
      key: "dateOfPurchase",
    },
    {
      dataIndex: "otherChargesLabel",
      key: "otherChargesLabel",
    },
    {
      dataIndex: "otherCharges",
      key: "otherCharges",
    },
  ];
  return (
    <Table
      loading={isCaseDetailsPending}
      className="borrower-details-table"
      showHeader={false}
      columns={columns}
      dataSource={data}
      size="middle"
      pagination={false}
    />
  );
};
